export default __webpack_public_path__ + "static/Simplicity-0e82de69a3d72aa0141fd2dd97b67109.svg";